<template>
  <v-container>
    <v-alert
      v-if="conceptsError"
      dismissible
      color="error"
      border="left"
      elevation="2"
      colored-border
      icon="priority_high"
    >An error happened while retrieving concepts: {{errorDisplay(conceptsError)}}</v-alert>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" icon dark class="mr-4" @click="refresh">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <OrganizationConceptsTab
      :organizationConcepts="organizationConcepts ? organizationConcepts : []"
      :concepts="concepts ? concepts : []"
      :conceptsLoading="conceptsLoading"
      :orgaConceptsLoading="orgaConceptsLoading"
      v-on:importConcept="importConcept"
      v-on:removeConcept="deleteConcept"
    />
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import OrganizationConceptsTab from "@/components/Admin/Organizations/OrganizationConceptsTab";

export default {
  mixins: [mixin],
  components: {
    OrganizationConceptsTab
  },
  data() {
    return {
      organizationUuid: this.$route.params.organizationId,
      errorMessage: "",
      snackbar: false,
      organizationConcepts: []
    };
  },
  computed: {
    ...mapState({
      concepts: state => state.concepts.all,
      conceptsError: state => state.concepts.fetchAll.error,
      conceptsLoading: state => state.concepts.fetchAll.pending,
      orgaConceptsLoading: state => state.organizations.fetchAllConcepts.pending
    })
  },
  methods: {
    ...mapActions("organizations", {
      fetchOne: "fetchOne",
      fetchAllOrganizationConcepts: "fetchAllConcepts",
      addConcept: "addConcept",
      removeConcept: "removeConcept"
    }),
    ...mapActions("concepts", { fetchAllConcepts: "fetchAll" }),
    refresh() {
      this.fetchAllConcepts().catch(error => {
        this.snackbar = true;
        this.errorMessage = this.errorDisplay(error);
      });
      this.fetchAllOrganizationConcepts({
        organizationUuid: this.organizationUuid
      })
        .then(concepts => {
          this.organizationConcepts = concepts;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    importConcept(conceptUuid) {
      this.addConcept({
        organizationUuid: this.organizationUuid,
        conceptUuid: conceptUuid
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteConcept(conceptUuid) {
      this.removeConcept({
        organizationUuid: this.organizationUuid,
        conceptUuid: conceptUuid
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.refresh();
  }
};
</script>

<style>
</style>